import { render, staticRenderFns } from "./EmailGroupForm.vue?vue&type=template&id=8607ffc4&"
import script from "./EmailGroupForm.vue?vue&type=script&lang=js&"
export * from "./EmailGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8607ffc4')) {
      api.createRecord('8607ffc4', component.options)
    } else {
      api.reload('8607ffc4', component.options)
    }
    module.hot.accept("./EmailGroupForm.vue?vue&type=template&id=8607ffc4&", function () {
      api.rerender('8607ffc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/email/EmailGroupForm.vue"
export default component.exports